import styled from 'styled-components';
var Container = styled.div.withConfig({
  displayName: "AffiliationBlockstyle__Container",
  componentId: "sc-vb68n4-0"
})(["display:flex;flex-direction:column;justify-content:center;margin:auto;"]);
export { Container };